import React, { useState } from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"

import Instagram from "../css/assets/instagram.inline.svg"
import Facebook from "../css/assets/facebook.inline.svg"
// import Hamburger from "../css/assets/hamburger.inline.svg";
import ArrowUpRight from "../css/assets/arrow-up-right.inline.svg"

import "../css/nav.css"

const Navigation = () => {
  const [menuOpen, setMenuOpen] = useState(false)

  function gtag_report_conversion() {
    if (typeof window !== "undefined" && window.gtag) {
      var callback = function () {
        window.location = "https://www.amalgamhomes.com/"
      }
      window.gtag("event", "conversion", {
        send_to: "AW-742462924/VNPHCMihy54YEMyrhOIC",
        event_callback: callback,
      })
      console.log("gtag_report_conversion")
      window.open("https://amalgamhomes.reserve-online.net/", "_blank")
      return false
    } else if (typeof window !== "undefined") {
      window.open("https://amalgamhomes.reserve-online.net/", "_blank")
    }
  }

  return (
    <React.Fragment>
      <nav className="nav-container">
        {/* hamburger menu icon */}
        {/* <button className="button-menu" onClick>
          <Hamburger className="hamburger" />
        </button> */}
        <div className="hamburger-menu-container">
          <input
            aria-label="Hamburger Menu"
            className="checkbox"
            type="checkbox"
            size="32"
            name=""
            id=""
            checked={menuOpen}
            onChange={() => setMenuOpen(!menuOpen)}
          />
          <div className="hamburger-lines">
            <span className="line line1"></span>
            <span className="line line2"></span>
            <span className="line line3"></span>
          </div>
        </div>
        <div className="title-socials">
          {/* vertical text - Amalgam Homes */}
          <span className="rotate-text">Amalgam Homes</span>
          {/* social media icons */}
          <div className="social-icons">
            <a
              href="https://www.instagram.com/amalgamhomes"
              aria-label="Instagram Link Amalgam Homes"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Instagram className="instagram" />
            </a>
            <a
              href="https://www.facebook.com/AmalgamHomes/"
              aria-label="Facebook Link Amalgam Homes"
              target="_blank"
              rel="noopener noreferrer"
            >
              <Facebook className="facebook" />
            </a>
          </div>
        </div>
      </nav>
      <div className={`menu ${menuOpen ? "open" : ""}`}>
        <div className="nav-menu-container">
          <div className="nav-menu-links">
            <div className="nav-links-col">
              <Link to="/" onClick={() => setMenuOpen(false)}>
                Home
              </Link>
            </div>
            <div className="nav-links-col">
              <span className="nav-links-col-title">Booking</span>
              <a
                href="https://amalgamhomesparos.reserve-online.net"
                target="_blank"
                rel="noopener noreferrer"
              >
                Reserve Paros
              </a>
              {/* <a
                href="https://dafnivilla.reserve-online.net"
                target="_blank"
                rel="noopener noreferrer"
              >
                Reserve Mykonos
              </a> */}
              <Link to="/inquiries" onClick={() => setMenuOpen(false)}>
                Reserve Naxos
              </Link>
              <Link to="/inquiries" onClick={() => setMenuOpen(false)}>
                Inquiries
              </Link>
            </div>
            <div className="nav-links-col">
              <span className="nav-links-col-title">Destinations</span>
              <Link to="/islands/paros" onClick={() => setMenuOpen(false)}>
                Paros
              </Link>
              <Link to="/islands/mykonos" onClick={() => setMenuOpen(false)}>
                Mykonos
              </Link>
              <Link to="/islands/naxos" onClick={() => setMenuOpen(false)}>
                Naxos
              </Link>
              <Link to="/islands/tinos" onClick={() => setMenuOpen(false)}>
                Tinos
              </Link>
            </div>
            <div className="nav-links-col">
              <span className="nav-links-col-title">Other</span>
              <Link to="/#about" onClick={() => setMenuOpen(false)}>
                About
              </Link>
              <Link to="/our-places" onClick={() => setMenuOpen(false)}>
                Our Places
              </Link>
              <Link to="/blog" onClick={() => setMenuOpen(false)}>
                Blog
              </Link>
              <Link to="/bespoke-services" onClick={() => setMenuOpen(false)}>
                Bespoke Services
              </Link>
            </div>
          </div>
          <div className="nav-menu-image">
            <StaticImage
              src="../images/358_9447_eolos_amalgam.webp"
              alt="Amalgam Homes - The art of comfort"
              placeholder="blurred"
              layout="fullWidth"
            />
          </div>
        </div>
      </div>
      <div className="book-button-container">
        <button
          aria-label="Book now"
          className="book pulse"
          onClick={gtag_report_conversion}
        >
          book now
          <ArrowUpRight height={19} width={19} />
        </button>
      </div>
    </React.Fragment>
  )
}

export default Navigation
